var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3216 13.7665C21.3216 12.8 22.1051 12.0165 23.0716 12.0165H44.0716C45.0381 12.0165 45.8216 12.8 45.8216 13.7665V34.7665C45.8216 35.733 45.0381 36.5165 44.0716 36.5165C43.1051 36.5165 42.3216 35.733 42.3216 34.7665V15.5165H23.0716C22.1051 15.5165 21.3216 14.733 21.3216 13.7665Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3089 12.529C45.9923 13.2125 45.9923 14.3205 45.3089 15.0039L15.6105 44.7025C14.9271 45.3859 13.819 45.3859 13.1356 44.7025C12.4522 44.0191 12.4522 42.911 13.1356 42.2276L42.834 12.529C43.5175 11.8456 44.6255 11.8456 45.3089 12.529Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUp);
export default __webpack_public_path__ + "static/media/arrow-right-up.03f0986e.svg";
export { ForwardRef as ReactComponent };